import styled, { RuleSet } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';
import { tagStyles } from '../../../ui/Typography/styles';

export const ResidenceSectionContainer = styled.section<{
  $styles?: RuleSet<object>;
}>`
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 14px;
  margin-bottom: 20px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 30px 40px;
    margin-bottom: 15px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 0;
    margin-bottom: 30px;
  }

  ${({ $styles }) => $styles};
`;

export const ResidenceSectionTitle = styled(Typography)`
  display: block;
  margin: 0 0 20px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${tagStyles.h4_new};
  }
`;
